import React from 'react';

import ProductFirstPriorityDetails from '../../../../components/product-first-priority-details/product-first-priority-details';
import ProductListStaggeredCardActions from './components/product-list-staggered-card-actions/product-list-staggered-card-actions';
import ProductListCardDetails from '../product-list-card-details/product-list-card-details';
import ProductListReviewDetails from '../product-list-review-details/product-list-review-details';

import {
  useProductEntryDataLayerValues,
  useProductQuantity
} from '../../../../shared/hooks/hooks';

import { trackAction } from '../../../../shared/utils/analytics/analytics';
import { getNormalizedProductType } from '../../../../shared/utils/product/product';
import { setSelectedProductAvailabilityStore } from '../../utils/product-list-page-multistore-utils';

import {
  BundleType,
  ProductData,
  ProductTypeEnum
} from '../../../../shared/types/graphql-types';
import { ProductItem } from '../../../../shared/types/product';

import './product-list-staggered-card.scss';

interface ProductListStaggeredCardProps {
  isTreadwellTabSelected: boolean;
  onAddProductClick: (productItem: ProductItem) => void;
  onCheckInventoryClick: () => void;
  onViewProductClick: () => void;
  product: ProductData;
}

function ProductListStaggeredCard(props: ProductListStaggeredCardProps) {
  const {
    isTreadwellTabSelected,
    onAddProductClick,
    onCheckInventoryClick,
    onViewProductClick,
    product
  } = props;

  const normalizedProductType =
    getNormalizedProductType(product) || ProductTypeEnum.Tires;
  const {
    defaultQuantity,
    quantity,
    rearQuantity,
    setQuantity,
    setRearQuantity,
    totalQuantity
  } = useProductQuantity({
    articleServiceType: product?.articleServiceType,
    bundleType: product?.rearProduct ? BundleType.StaggeredSet : undefined,
    productType: normalizedProductType
  });

  const productDetailUrl = product?.url || '';

  const { getProductEntryDataLayerValues } = useProductEntryDataLayerValues();

  if (window['isPreRendering']) {
    return <div styleName="container" />;
  }

  return (
    <div
      data-testid="product-list-staggered-card"
      id={product && product.code ? `product-code-${product.code}` : ''}
      styleName="container"
    >
      <ProductListCardDetails
        hideProductSize
        onCheckInventoryClick={onCheckInventoryClick}
        onViewProductClick={onViewProductClick}
        product={product}
        productDetailUrl={productDetailUrl}
        quantity={quantity}
        rearQuantity={rearQuantity}
      />

      <ProductListStaggeredCardActions
        defaultQuantity={defaultQuantity}
        onAddProductClick={onAddProductClick}
        onQuantityChange={setQuantity}
        onRearQuantityChange={setRearQuantity}
        product={product}
        quantity={quantity}
        rearQuantity={rearQuantity}
        totalQuantity={totalQuantity}
      />

      {normalizedProductType === ProductTypeEnum.Tires &&
        (product?.recommendationData || product?.tdsData ? (
          <ProductFirstPriorityDetails
            dataReportUrl={productDetailUrl}
            onClick={() => {
              trackAction(
                'product_view_pdl_data_click',
                getProductEntryDataLayerValues(product)
              );
              setSelectedProductAvailabilityStore(product);
            }}
            product={product}
          />
        ) : (
          <ProductListReviewDetails
            isTreadwellTabSelected={isTreadwellTabSelected}
            numberOfReviews={product?.reviewSummaryData?.totalCount || 0}
            onClickReadReviewsFn={() =>
              setSelectedProductAvailabilityStore(product)
            }
            product={product}
            productDetailUrl={productDetailUrl}
          />
        ))}
    </div>
  );
}

export default ProductListStaggeredCard;
